import { create } from '@thoughtspot/logger';
import _ from 'lodash';
import { getEventSession } from './event-session-service';
import { PeopleIncrementalPropertiesEnum, PeoplePropertiesEnum, PeopleSetPropertiesEnum, updatePeopleProperty, } from './mixpanel-people-properties';
import { SessionPropsEnum, } from './mixpanel-session-properties';
let mixpanelDNT = false;
export let mixpanel;
let mixpanelSessionProperties;
let isMixpanelEnabled;
let resolveMixpanelReady;
export const mixpanelReady = new Promise(resolve => {
    resolveMixpanelReady = resolve;
});
const Logger = create('mixpanel-service');
export async function initService(token, mixpanelLib, mixpanelSessionProps, debugMode, mixpanelApiHost, enableCrossSubDomainCookie, useLocalStorage, enableABTesting, enableSessionReplay) {
    mixpanel = mixpanelLib;
    const persistence = useLocalStorage ? 'localStorage' : 'cookie';
    if (mixpanelApiHost) {
        mixpanel.init(token, {
            api_host: mixpanelApiHost,
            cross_subdomain_cookie: enableCrossSubDomainCookie,
            persistence,
            flags: enableABTesting,
        });
    }
    else {
        mixpanel.init(token, {
            cross_subdomain_cookie: enableCrossSubDomainCookie,
            persistence,
            flags: enableABTesting,
        });
    }
    if (debugMode) {
        mixpanel.set_config({ debug: true });
    }
    mixpanel.set_config({ ignore_dnt: true });
    mixpanelSessionProperties = mixpanelSessionProps;
    isMixpanelEnabled = true;
    return true;
}
export function uploadEvent(eventId, eventProps) {
    mixpanel.track(eventId, eventProps);
}
export function uploadEventBatch(eventBatch) {
    eventBatch.forEach((evt) => {
        uploadEvent(evt.id, evt.props);
    });
}
export function isBlocked(url = 'https://api.mixpanel.com/') {
    return fetch(url, { mode: 'no-cors' })
        .then(() => false)
        .catch(() => true);
}
export function isOptedOut() {
    return mixpanel.has_opted_out_tracking();
}
export function setOptInTracking() {
    mixpanel.clear_opt_in_out_tracking();
    mixpanel.opt_in_tracking();
}
export function updateMixPanelProperty(key, value) {
    if (!isMixpanelEnabled) {
        return;
    }
    const isInPeopleProperties = _.includes(_.values(PeoplePropertiesEnum), key) ||
        _.includes(_.values(PeopleIncrementalPropertiesEnum), key) ||
        _.includes(_.values(PeopleSetPropertiesEnum), key);
    const isInSessionProperties = _.includes(_.values(SessionPropsEnum), key);
    if (!isInPeopleProperties && !isInSessionProperties) {
        throw new Error('Property does not exists in current set of properties');
    }
    if (isInPeopleProperties) {
        updatePeopleProperty(key, value);
    }
    if (isInSessionProperties) {
        mixpanelSessionProperties.updateSessionProperty(key, value);
    }
}
export function getSessionProperties() {
    return getEventSession();
}
export function isMixpanelDNT() {
    return mixpanelDNT;
}
export function setMixpanelDNT(value) {
    mixpanelDNT = value;
}
export const resetMixpanelOnLogout = () => {
    try {
        mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.reset();
    }
    catch (error) {
        Logger.error('Error occurred while resetting Mixpanel:', error);
    }
};
export const notifyMixpanelIdentified = () => {
    resolveMixpanelReady();
};
export const notifyMixpanelDisabled = () => {
    resolveMixpanelReady();
};
export const getVariantValueSync = (flagName, fallbackValue) => {
    var _a;
    if (!isMixpanelEnabled || !((_a = mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.flags) === null || _a === void 0 ? void 0 : _a.get_variant_value_sync)) {
        return fallbackValue;
    }
    return mixpanel.flags.get_variant_value_sync(flagName, fallbackValue);
};
export const getVariantValue = async (flagName, fallbackValue) => {
    var _a;
    if (!isMixpanelEnabled || !((_a = mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.flags) === null || _a === void 0 ? void 0 : _a.get_variant_value)) {
        return fallbackValue;
    }
    try {
        return await mixpanel.flags.get_variant_value(flagName, fallbackValue);
    }
    catch (e) {
        Logger.warn('Feature flag fetch failed', e);
        return fallbackValue;
    }
};
export const variantFlagsReady = () => { var _a, _b; return !!(isMixpanelEnabled && ((_b = (_a = mixpanel === null || mixpanel === void 0 ? void 0 : mixpanel.flags) === null || _a === void 0 ? void 0 : _a.are_flags_ready) === null || _b === void 0 ? void 0 : _b.call(_a))); };
//# sourceMappingURL=mixpanel-service.js.map